import { render, staticRenderFns } from "./px-table-header.vue?vue&type=template&id=2d9d71ba&scoped=true&"
import script from "./px-table-header.vue?vue&type=script&lang=ts&"
export * from "./px-table-header.vue?vue&type=script&lang=ts&"
import style0 from "./px-table-header.vue?vue&type=style&index=0&id=2d9d71ba&lang=scss&scoped=true&"
import style1 from "./px-table-header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d71ba",
  null
  
)

export default component.exports